import {atom} from 'jotai'
// import { atomWithStorage } from 'jotai/utils';

import {
  ComissionList,
  CommissionDetail,
  ListFilter,
  Merchant,
  RecentTransactions,
  Store,
  UserDetail,
} from '../domain'

export const storeDetailAtom = atom<Store | null>(null)
export const merchantDetailAtom = atom<Merchant | null>(null)
export const recentTransactionsAtom = atom<RecentTransactions | null>(null)

// export const tabAtom = atomWithStorage<'Overview' | 'Contact' | 'Subscription' | 'Invoice' | 'Transaction' | 'Terminal' | 'Optional' | 'User' | 'Engagement' | 'SmsEngagement' | 'PushEngagement' | 'EmailEngagement'>("StoreTab", "Overview");
export const tabAtom = atom<
  | 'Overview'
  | 'Contact'
  | 'Subscription'
  | 'Invoice'
  | 'Transaction'
  | 'TPN'
  | 'Activities'
  | 'Optional'
  | 'User'
  | 'UserDetail'
  | 'Commission'
  | 'CommissionDetail'
  | 'Engagement'
  | 'SmsEngagement'
  | 'PushEngagement'
  | 'EmailEngagement'
  | 'Locations'
>('Overview')

export const userDetailAtom = atom<UserDetail | null>(null)

export const comissionDetailAtom = atom<CommissionDetail | null>(null)

const list: ComissionList = {
  dataList: [],
  paging: {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 10,
    totalCount: 0,
  },
}

export const commissionListAtom = atom<ComissionList>(list)
export const commissionListFilterAtom = atom<any>({
  filterList: [],
  orderList: [{type: 2, key: 'CreatedOn'}],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
  search: {
    value: '',
    keyList: [],
  },
})

export const isoListAtom = atom<[]>([])

// export const tabFilterAtom = atom<FilterList>([])
export const tabFilterAtom = atom<{
  filterList: ListFilter[]
  paging: {
    currentPageNumber: number
    pageSize: number
  }
}>({
  filterList: [],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})
